import { Box } from "@mui/material";
import { JSX, PropsWithChildren } from "react";
import { Typography } from "@platform/design-system";

type Props = PropsWithChildren<unknown>;

function ErrorMessage({ children }: Props): JSX.Element {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", height: "100%" }}>
      <Typography variant="header-large" color="danger">
        {children}
      </Typography>
    </Box>
  );
}

export default ErrorMessage;
